import {Avatar, Input} from 'antd'
import {auth_fetchOrganizationsWithAdminAuth_Api, auth_updateOrg_Api,} from 'apis'
import {getId} from 'apis/model/base'
import classNames from 'classnames'
import {LoginContext} from 'components/LoginContext'
import getAvatar from 'helpers/getAvatar'
import getTitle from 'helpers/getTitle'
import Translate from 'modules/local/Translate'
import useTranslate from 'modules/local/useTranslate'
import {NavigationContext} from 'modules/navigation/NavigationContext'
import React, {useContext, useState,} from 'react'
import EntityList from 'views/AppLocals/EntityList'
import {useDeBounceValue} from 'views/Search/useDeBounceValue'
import {NullAsDefault, renderFalse} from 'views/Shared'
import {BiSolidChurch} from "react-icons/bi";
import {OrgType} from "../../AppLocals/Organization/components/OrgType";
import {PiChecksBold} from "react-icons/pi";
import WorkspaceContext from "../WorkspaceContext";
import useAsyncAction from "../../../modules/asyncCache/useAsyncAction";
import _ from "lodash";
import {NotificationActionTypes, successNotify} from "../../AppLocals/factory/createNotification";
import {getRouteSearchParams} from "../../../envs/_current/history";
import {notifyOnError} from "../../AppLocals/factory/createErrorEvent";
import {useRouterSearchParam} from "../../../modules/navigation/useOnLocationChange";

export const WorkspaceAvatar = ({src, style, onClick, ...props}) => (
    <Avatar
        src={src}
        style={style}
        onClick={onClick}
        {...props}
    />
)

const excludedKeys = {
    all: '__workspace_picker_more__',
}


const renderOrganizationRow = ({onItemSelected = NullAsDefault, isSelected = renderFalse}) => (item) => {
    const id = getId(item)
    const selected = !!isSelected(id)

    return (
        <div
            key={id}
            onClick={() => {
                if (!selected) {
                    onItemSelected(item)
                }
            }}

            className={classNames(
                'p-3 flex flex-col rounded-xl',
                !selected ? 'border border-color-50 shadow-md hover:scale-2xs cursor-pointer' : 'border-2 border-indigo-500'
            )}>
            <div className="mb-2 pb-2 border-b border-color-50 flex items-center flex-1 gap-3">
                <WorkspaceAvatar
                    size={50}
                    className="flex flex-center bg-primary-50 rounded-lg"
                    src={getAvatar(item)}
                    icon={<BiSolidChurch size={30} className="text-primary-400"/>}
                />
                <div className="flex flex-col flex-1">
                    <div className="font-bold text-base text-color-000 leading-snug max-lines-1">
                        {getTitle(item)}
                    </div>
                    <OrgType item={item} className="font-medium text-xs text-blue-500 italic tracking-wide"/>
                </div>
            </div>
            <div className="flex justify-end">
                <Translate>
                    {(t) => (
                        selected ? (
                            <span style={{padding: '2px 10px'}}
                                  className="flex items-center font-medium text-xs text-green-600 rounded-md italic">
                                <PiChecksBold size={12} className="mr-1 text-green-600"/>
                                {t('selected')}
                            </span>
                        ) : (
                            <span style={{padding: '2px 10px'}}
                                  className="bg-primary-50 hover:bg-primary-100 font-medium text-xs text-primary-600 rounded-xs">
                                {t('select')}
                            </span>
                        )
                    )}
                </Translate>
            </div>
        </div>
    )
}

export const AdminOrganizations = () => {
    const t = useTranslate()
    const {onChangeSearchParams} = useRouterSearchParam({});
    const {setCurrent, handleGoBack = NullAsDefault} = useContext(NavigationContext)
    const {organization} = useContext(WorkspaceContext)
    const login = useContext(LoginContext)
    const primary_id = getId(organization)
    const {isLoading, handleAsyncAction: updateDefaultOrg} = useAsyncAction({
        apiInfo: auth_updateOrg_Api,
        onSuccess: (result, data) => {
            const dataItem = _.get(data, 'response.data');
            successNotify(NotificationActionTypes.UPDATE, t)
            const _searchParams = getRouteSearchParams();
            const _searchParamObj = Object.fromEntries(_searchParams.entries());

            if (!!dataItem?.primary_org) {
                _searchParamObj.org_id = getId(dataItem?.primary_org) || dataItem?.primary_org;
                onChangeSearchParams(_searchParamObj);
            }
        },
        onError: notifyOnError(t),
    })

    const onItemSelected = (item) => {
        const result = getId(item)
        updateDefaultOrg({organization_id: item?.id})
        setCurrent({
            key: excludedKeys.all,
            value: result,
        })
        // handleGoBack()
    }

    const [keyword, setKeyword] = useState()

    const debouncedValue = useDeBounceValue(keyword, 500)

    return (
        <div className="space-y-6 mb-6">
            {/*<div className="font-bold text-center text-lg text-color-000 uppercase">*/}
            {/*    {t('choose organization')}*/}
            {/*</div>*/}
            <div className="flex flex-col gap-4">
                <Input.Search
                    allowClear={true}
                    placeholder={t('keyword')}
                    onChange={(event) => {
                        setKeyword(event.target.value)
                    }}
                    className="input-search-with-icon"
                />
                <div className="flex flex-col gap-4">
                    <EntityList
                        key={debouncedValue}
                        values={{
                            keyword: debouncedValue,
                            filter_group: 'admin'
                        }}
                        apiInfo={auth_fetchOrganizationsWithAdminAuth_Api}
                        RenderEntity={React.Fragment}
                        renderItem={renderOrganizationRow({
                            onItemSelected,
                            isSelected: (id) => id === primary_id,
                        })}
                    />
                </div>
            </div>
        </div>
    )
}


export default AdminOrganizations
